"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCurrenciesByMarketcap = exports.currenciesByMarketcap = exports.useMarketcapTickers = exports.getMarketcapTickers = exports.sortByMarketcap = void 0;
const index_1 = require("@ledgerhq/coin-framework/currencies/index");
const cryptoassets_1 = require("@ledgerhq/cryptoassets");
const cache_1 = require("@ledgerhq/live-network/cache");
const react_1 = require("react");
const api_1 = __importDefault(require("../countervalues/api"));
// FIXME in future we would put it back in ledgerjs to be more "dynamic"
let currenciesAndTokenWithCountervaluesByTicker;
function lazyLoadTickerMap() {
    if (currenciesAndTokenWithCountervaluesByTicker)
        return currenciesAndTokenWithCountervaluesByTicker;
    const m = new Map();
    (0, cryptoassets_1.listTokens)().forEach(t => {
        if (!t.disableCountervalue && !m.has(t.ticker)) {
            m.set(t.ticker, t);
        }
    });
    (0, index_1.listCryptoCurrencies)().forEach(c => {
        var _a;
        if (!c.disableCountervalue &&
            // FIXME Avoid duplicates & override if the already set currency is a token
            // E.g. 'Binance-Peg Ethereum Token' has an 'ETH' ticker
            (!m.has(c.ticker) || ((_a = m.get(c.ticker)) === null || _a === void 0 ? void 0 : _a.type) !== "CryptoCurrency")) {
            m.set(c.ticker, c);
        }
    });
    currenciesAndTokenWithCountervaluesByTicker = m;
    return m;
}
const sortByMarketcap = (currencies, tickers) => {
    const m = lazyLoadTickerMap();
    const list = currencies.slice(0);
    const prependList = [];
    tickers.forEach(ticker => {
        const item = m.get(ticker);
        if (item) {
            const i = list.indexOf(item);
            if (i !== -1) {
                list.splice(i, 1);
                prependList.push(item);
            }
        }
    });
    return prependList.concat(list);
};
exports.sortByMarketcap = sortByMarketcap;
let marketcapTickersCache;
exports.getMarketcapTickers = (0, cache_1.makeLRUCache)(() => api_1.default.fetchMarketcapTickers().then(tickers => {
    marketcapTickersCache = tickers;
    return tickers;
}));
// React style version of getMarketcapTickers
const useMarketcapTickers = () => {
    const [tickers, setMarketcapTickers] = (0, react_1.useState)(marketcapTickersCache);
    (0, react_1.useEffect)(() => {
        let isMounted = true;
        (0, exports.getMarketcapTickers)().then(data => {
            if (isMounted)
                setMarketcapTickers(data);
        });
        return () => {
            isMounted = false;
        };
    }, []);
    return tickers;
};
exports.useMarketcapTickers = useMarketcapTickers;
const currenciesByMarketcap = (currencies) => (0, exports.getMarketcapTickers)().then(tickers => (0, exports.sortByMarketcap)(currencies, tickers), () => currencies);
exports.currenciesByMarketcap = currenciesByMarketcap;
// React style version of currenciesByMarketcap
const useCurrenciesByMarketcap = (currencies) => {
    const tickers = (0, exports.useMarketcapTickers)();
    return tickers ? (0, exports.sortByMarketcap)(currencies, tickers) : currencies;
};
exports.useCurrenciesByMarketcap = useCurrenciesByMarketcap;
//# sourceMappingURL=sortByMarketcap.js.map